import { Button, CardMedia, Stack, Typography } from '@mui/material';
import React, { FC, ReactNode } from 'react';

import { StyledBookingCard, StyledBookingCardContent, StyledCardActions } from './style';

interface BookingCardButton {
  label: string;
  onClick: () => void;
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  variant?: 'text' | 'outlined' | 'contained';
}

interface IBookingCard {
  imageUrl: string;
  content: ReactNode;
  title: string;
  buttons?: BookingCardButton[];
  style?: React.CSSProperties;
}

const BookingCard: FC<IBookingCard> = ({ imageUrl, title, content, buttons = [], style }) => (
  <StyledBookingCard style={style}>
    <CardMedia component="img" height="240" image={imageUrl} alt={title} />
    <StyledBookingCardContent>
      <Typography sx={{ mt: 5, mb: 4 }} variant="h4">
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ minHeight: { xs: 208, md: 176 } }}>
        {content}
      </Typography>
    </StyledBookingCardContent>
    <StyledCardActions>
      <Stack direction="row" spacing={2} width="100%">
        {buttons.map((btn, index) => (
          <Button
            key={index}
            size="large"
            color={btn.color || 'primary'}
            variant={btn.variant || 'contained'}
            sx={{ width: '100%', mb: 1 }}
            onClick={btn.onClick}>
            {btn.label}
          </Button>
        ))}
      </Stack>
    </StyledCardActions>
  </StyledBookingCard>
);

export default BookingCard;
